import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useState } from 'react'
import { Box, CssBaseline } from '@mui/material';
import { Header } from './Components/Header';
import { SideNavBar } from './Components/SideNavBar';
import { ProblemFormulation } from './Components/MainComponents/ProblemFormulation';
import { SurrogateGeneration } from './Components/MainComponents/SurrogateGeneration';
import { PerformancePlots } from './Components/MainComponents/PerformancePlots';
import { Optimization } from './Components/MainComponents/Optimization';
import { ManageModels } from './Components/MainComponents/ManageModels';
import { ReactAuthWrapper } from "@carrier-sce-sharedpackages/reactauthwrapper";
import appConfig from "./config";

const drawerWidth = 300;
const collapsedWidth = 80;

function App() {
const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);

  const styles = {
    backgroundColor: '#ecf1ff',
    flexGrow: 1,
    padding: "18px 24px",
    // marginLeft: " 100px",
    // height: "92vh",
    marginTop: "60px",

    transition: 'margin-left 0.3s',
    marginLeft: isSidebarExpanded ? `${drawerWidth}px` : `${collapsedWidth}px`,

  };

  const [appAccess, setAppAccess] = useState(false);
  
  const callback = (permissions) => {
    console.log("permissions->", permissions);
    if (permissions.appAccess) {
      console.log("permissions->", permissions.appAccess);
      setAppAccess(true);
    }
  };



  return (
    <ReactAuthWrapper appConfig={appConfig.api} getPermissions={callback}>
      {appAccess && (
        <Router>
          <CssBaseline />

          <SideNavBar 
          isExpanded={isSidebarExpanded}
        setIsExpanded={setIsSidebarExpanded}/>

          <Box sx={{ display: 'flex' }}>
            <Header isExpanded={isSidebarExpanded}/>

            <Box component="main" sx={styles} >
              <Routes>
                <Route path='/' element={<ProblemFormulation />} />
                <Route path='/surrogate-generation' element={<SurrogateGeneration />} />
                <Route path='/performance-plots' element={<PerformancePlots />} />
                <Route path='/optimization' element={<Optimization />} />
                <Route path='/manage-models' element={<ManageModels />} />
              </Routes>
            </Box>
          </Box>
        </Router>
      )}
    </ReactAuthWrapper>

  );
}

export default App;
